// extracted by mini-css-extract-plugin
export default {"loader":"playLeaderboardLoader_loader__mU4rN"};